 export const customStyles = {
  control: (base) => ({
    ...base,
    fontSize: '0.8rem',
    minHeight: '30px',  
    height: 'auto',    
    boxShadow: null,
    borderRadius: '5px',
    backgroundColor: 'white',
    padding: '0 8px', 
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
    overflow: 'visible',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    fontSize: '0.8rem',
    backgroundColor: isFocused || isSelected ? 'lightblue' : 'white',
    borderRadius: '8px',
    color: isDisabled ? '#ccc' : 'black',
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    borderRadius: '5px',
    minHeight: '30px', 
    padding: '0',
    overflowY: "auto"      
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '30px', 
  }),
  singleValue: (provided) => ({
    ...provided,
    overflow: 'hidden', 
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'black',
  }),
};

 export const the = (theme) => ({
  ...theme,
  borderRadius: 0,
  colors: {
    ...theme.colors,
    primary25: 'neutral80',
    primary: 'black',
  },
});

 export const modelDropdown = {
  control: (base) => ({
    ...base,
    fontSize: '0.8rem',
    minHeight: '30px',  
    height: 'auto',    
    boxShadow: null,
    borderRadius: '5px',
    backgroundColor: 'white',
    padding: '0 1px', 
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
    overflow: 'visible',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => ({
    ...styles,
    fontSize: '0.8rem',
    backgroundColor: isFocused || isSelected ? 'lightblue' : 'white',
    borderRadius: '8px',
    color: isDisabled ? '#ccc' : 'black'
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    borderRadius: '5px',
    minHeight: '30px', 
    padding: '0',
    overflowY: "auto"      
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '30px', 
  }),
  singleValue: (provided) => ({
    ...provided,
    overflow: 'hidden', 
  }),
  placeholder: (provided) => ({
    ...provided,
    color: 'black',
  }),
};